export const LOGIN = '[Auth] LOGIN';
export type LOGIN = typeof LOGIN;

export const LOGIN_SUCCESS = '[Auth] LOGIN_SUCCESS';
export type LOGIN_SUCCESS = typeof LOGIN_SUCCESS;

export const LOGIN_HAS_ERRORED = '[Auth] LOGIN_HAS_ERRORED';
export type LOGIN_HAS_ERRORED = typeof LOGIN_HAS_ERRORED;

export const GET_LOGGED_IN_USER = '[Auth] GET_LOGGED_IN_USER';
export type GET_LOGGED_IN_USER = typeof GET_LOGGED_IN_USER;

export const GET_LOGGED_IN_USER_SUCCESS = '[Auth] GET_LOGGED_IN_USER_SUCCESS';
export type GET_LOGGED_IN_USER_SUCCESS = typeof GET_LOGGED_IN_USER_SUCCESS;

export const LOGOUT = '[Auth] LOGOUT';
export type LOGOUT = typeof LOGOUT;

export const LOGOUT_SUCCESS = '[Auth] LOGOUT_SUCCESS';
export type LOGOUT_SUCCESS = typeof LOGOUT_SUCCESS;

export const EMAIL_RESET_PWD = '[Auth] EMAIL_RESET_PWD';
export type EMAIL_RESET_PWD = typeof EMAIL_RESET_PWD;

export const EMAIL_RESET_PWD_SUCCESS = '[Auth] EMAIL_RESET_PWD_SUCCESS';
export type EMAIL_RESET_PWD_SUCCESS = typeof EMAIL_RESET_PWD_SUCCESS;

export const EMAIL_RESET_PWD_HAS_ERRORED = '[Auth] EMAIL_RESET_PWD_HAS_ERRORED';
export type EMAIL_RESET_PWD_HAS_ERRORED = typeof EMAIL_RESET_PWD_HAS_ERRORED;

export const RESET_PASSWORD_ROUTE = '[Auth] RESET_PASSWORD_ROUTE';
export type RESET_PASSWORD_ROUTE = typeof RESET_PASSWORD_ROUTE;

export const SET_RESET_CONF = '[Auth] SET_RESET_CONF';
export type SET_RESET_CONF = typeof SET_RESET_CONF;

export const RESET_PASSWORD = '[Auth] RESET_PASSWORD';
export type RESET_PASSWORD = typeof RESET_PASSWORD;

export const RESET_PASSWORD_SUCCESS = '[Auth] RESET_PASSWORD_SUCCESS';
export type RESET_PASSWORD_SUCCESS = typeof RESET_PASSWORD_SUCCESS;

export const RESET_PASSWORD_HAS_ERROR = '[Auth] RESET_PASSWORD_HAS_ERROR';
export type RESET_PASSWORD_HAS_ERROR = typeof RESET_PASSWORD_HAS_ERROR;

export const CHECK_RESET_TOKEN = '[Auth] CHECK_RESET_TOKEN';
export type CHECK_RESET_TOKEN = typeof CHECK_RESET_TOKEN;

export const CHECK_RESET_TOKEN_SUCCESS = '[Auth] CHECK_RESET_TOKEN_SUCCESS';
export type CHECK_RESET_TOKEN_SUCCESS = typeof CHECK_RESET_TOKEN_SUCCESS;

export const CHECK_RESET_TOKEN_HAS_ERROR = '[Auth] CHECK_RESET_TOKEN_HAS_ERROR';
export type CHECK_RESET_TOKEN_HAS_ERROR = typeof CHECK_RESET_TOKEN_HAS_ERROR;
